class MediaVideoComponent extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.btn = this.querySelector('.media-block__play-btn');
    if (!this.video || !this.btn) return;

    if (this.btn.dataset.playing === 'true') {
      this.video.play().catch(() => {});
    }

    this.btn.addEventListener('click', () => {
      if (this.video.paused) {
        this.video.play().catch(() => {});
        this.setPlaying(true);
      } else {
        this.video.pause();
        this.setPlaying(false);
      }
    });
  }

  setPlaying(playing) {
    const playIcon = this.btn.querySelector('.svg-wrapper--play');
    const pauseIcon = this.btn.querySelector('.svg-wrapper--pause');
    if (playIcon) playIcon.hidden = playing;
    if (pauseIcon) pauseIcon.hidden = !playing;
    this.btn.setAttribute('aria-label', playing
      ? this.btn.dataset.pauseLabel || 'Pause video'
      : this.btn.dataset.playLabel || 'Play video'
    );
    this.btn.dataset.playing = playing ? 'true' : 'false';
  }
}

customElements.define('media-video', MediaVideoComponent);
